import React from "react";
import { useNavigate } from "react-router";
import { Button, Col, Container, Row } from "react-bootstrap";

export const ExtraMails = (props) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Row>
        <Col>
          <div className="thanks-section">
            <h2>Thank You For Choosing Fernwood Cemetery</h2>
            <div className="thank-box">
              <p className="">Your payment has been successfully processed.</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ExtraMails;
